import { Fragment, useState } from 'react'
import { Transition } from '@headlessui/react'
import { useNotification } from '../providers/NotificationProvider';
import Cta from '../components/Cta'
import {
  useLocation,
  useHistory
} from "react-router-dom";
import AuthService from '../services/AuthService'

const queryString = require('query-string');

const formClass = "appearance-none block w-full px-8 py-4 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-primary text-login-form-input";

function ConfirmForm() {
  const query = useLocation().search;
  const params = queryString.parse(query);

  const history = useHistory();

  const [ notification, notificationDispatch ] = useNotification();
  const [showForm, setShowForm] = useState(false);
  const [form, setFormData] = useState({
    code: params.c,
    email: params.u,
    password: "",
    confirm: ""
  });

  const handleSubmit = (evt) => {
    evt.preventDefault();

    if (form.password !== form.confirm) {
        notificationDispatch({ type: 'show_notification', payload: { message: "Password mismatch" } });
        return;
    }

    AuthService.resetPassword(form.code, form.email, form.password).then((response) => {
      if (response.data.errors) {
        notificationDispatch({ type: 'show_notification', payload: { message: response.data.errors.message } });
      } 

      let resetPassword = response.data.data.resetPassword;
      if (resetPassword.success === true) {
        notificationDispatch({ type: 'show_notification', payload: { message: "Password Successfully Reset" } });
        history.replace('/login');
      } else {
        notificationDispatch({ type: 'show_error', payload: { message: resetPassword.message} });
      }
    });

  }

  return (
    <div className="mt-6 sm:mx-auto md:w-120">
      <div className="bg-white px-4 sm:rounded-lg sm:px-10">
        <form className="space-y-6" onSubmit={handleSubmit} method="POST">
          <input 
            id="code"
            type="hidden"
            placeholder='Code'
            className={formClass}
            value={form.code}
          />

          <input 
            id="password"
            type="password"
            placeholder='New Password'
            className={formClass}
            value={form.password}
            onChange={(evt) => setFormData({...form, password: evt.target.value})}
            required
          />
          <input 
            id="confirm"
            type="password"
            placeholder='Confirm Password'
            className={formClass}
            value={form.confirm}
            onChange={(evt) => setFormData({...form, confirm: evt.target.value})}
            required
          />

          <div>
            <button
              type="submit"
              className="inline-flex items-center justify-center px-14 py-4 border border-transparent font-cta-label text-cta-label-mobile md:text-cta-label font-medium rounded-full text-white bg-blue-500 hover:bg-blue-400 disabled:bg-grey-light"
            >Confirm</button>
          </div>
        </form>
      </div>

    </div>
  )
}

export default ConfirmForm;

